import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import {
  ExamsActions,
  ExamsDetailsState,
  ExamsListResponse,
  ExamsQuestionItemState,
  ExamsQuestionsListItemState,
  ExamsResultState,
  ExamsState,
  ExamsTimeLeft,
} from '../types';

const initialState: ExamsState = {
  exams: [],
  examsDetails: undefined!,
  questions: [],
  questionCache: {},
  question: undefined!,
  examsAction: null,
  itensPerPage: 0,
  currentPage: 0,
  totalPages: 0,
  result: undefined!,
  timeLeft: undefined!,
};

const examsSlice = createSlice({
  name: 'exams',
  initialState,
  reducers: {
    setExamsAction(state, action: PayloadAction<ExamsListResponse>) {
      const { exams, itensPerPage, currentPage, totalPages } = action.payload;

      state.exams = exams;
      state.itensPerPage = itensPerPage;
      state.currentPage = currentPage;
      state.totalPages = totalPages;
    },

    clearExamsAction(state) {
      state.exams = [];
      state.itensPerPage = 0;
      state.currentPage = 0;
      state.totalPages = 0;
    },

    setExamsDetailsAction(state, action: PayloadAction<ExamsDetailsState>) {
      state.examsDetails = action.payload;
    },

    clearExamsDetailsAction(state) {
      state.examsDetails = undefined!;
    },

    setExamsActionAction(state, action: PayloadAction<ExamsActions>) {
      state.examsAction = action.payload;
    },

    setExamsQuestionsListAction(state, action: PayloadAction<ExamsQuestionsListItemState[]>) {
      state.questions = action.payload;
    },

    clearExamsQuestionsListAction(state) {
      state.questions = undefined!;
    },

    setExamsQuestionAction(state, action: PayloadAction<ExamsQuestionItemState>) {
      state.question = action.payload;
    },

    clearExamsQuestionAction(state) {
      state.question = undefined!;
    },

    setExamsQuestionCacheAction(state, action: PayloadAction<ExamsQuestionItemState>) {
      state.questionCache = { ...state.questionCache, [action.payload.uuid]: action.payload };
    },

    cleatExamsQuestionCacheAction(state) {
      state.questionCache = {};
    },

    setExamsResultAction(state, action: PayloadAction<ExamsResultState>) {
      state.result = action.payload;
    },

    clearExamsResultAction(state) {
      state.result = undefined!;
    },

    setExamsTimeLeftAction(state, action: PayloadAction<ExamsTimeLeft>) {
      state.timeLeft = action.payload;
    },

    clearExamsTimeLeftAction(state) {
      state.timeLeft = undefined!;
    },
  },
});

export const {
  setExamsAction,
  clearExamsAction,
  setExamsDetailsAction,
  clearExamsDetailsAction,
  setExamsActionAction,
  setExamsQuestionsListAction,
  clearExamsQuestionsListAction,
  setExamsQuestionAction,
  clearExamsQuestionAction,
  setExamsResultAction,
  clearExamsResultAction,
  setExamsTimeLeftAction,
  clearExamsTimeLeftAction,
  setExamsQuestionCacheAction,
  cleatExamsQuestionCacheAction,
} = examsSlice.actions;

export const getExams = (state: RootState): ExamsState => state.exams;

export default examsSlice.reducer;
